import { render, staticRenderFns } from "./TemplateDownloadButton.vue?vue&type=template&id=7faf8caf&"
import script from "./TemplateDownloadButton.vue?vue&type=script&lang=js&"
export * from "./TemplateDownloadButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports